// Build-time phone settings. The SIP host allow-list comes from the application, never
// from a bootstrap payload: the page's own host, its `sip.` sibling (the deployed PBX
// convention, for example sip.sidet.one beside sidet.one) and VITE_SIDETONE_SIP_HOSTS.
export const CLIENT_VERSION = 'sidetone-web/0.1.0';

const HOST = /^[a-z0-9.-]{1,253}$/;

export function allowedSipHosts(pageHost: string | null = typeof location === 'undefined' ? null : location.hostname, extra: string | undefined = readEnv()): string[] {
  const hosts = new Set<string>();
  const page = pageHost?.toLowerCase() ?? '';
  if (page && HOST.test(page) && page !== 'localhost' && page.includes('.')) {
    hosts.add(page);
    if (!page.startsWith('sip.')) hosts.add(`sip.${page}`);
  }
  for (const raw of (extra ?? '').split(',')) {
    const host = raw.trim().toLowerCase();
    if (host && HOST.test(host)) hosts.add(host);
  }
  return [...hosts];
}

function readEnv(): string | undefined {
  try {
    const value: unknown = import.meta.env?.VITE_SIDETONE_SIP_HOSTS;
    return typeof value === 'string' ? value : undefined;
  } catch {
    return undefined;
  }
}
